<template lang="pug">
v-card.ma-4.pa-4(flat)
  .mx-8
    v-row(align="baseline")
      v-col(cols=12 lg=4)
        v-row
          v-col(cols=12, align="center")
            p Where do you live?
          v-col(cols=12) 
            AddressFinder(
              :model="bubble.location",
              :clear="true",
              label="Enter an address here"
            )
      v-col(cols=12 lg=4)
        v-row
          v-col(cols=12, align="center")
            p Roughly, how much driving do you do?
          v-col(cols=12) 
            v-text-field.centered-input(
              v-model="bubble.kms",
              type="number",
              append-outer-icon="mdi-plus-circle-outline",
              @click:append-outer="increment",
              prepend-icon="mdi-minus-circle-outline",
              @click:prepend="decrement",
              min=0,
              onkeyup="if(this.value < 0) this.value = 0;"
            )
            v-row(justify="center", align="center")
              v-col.center(cols=6)
                span.km-indicator {{ bubble.kms }}km per week
                br
                span.petrol-indicator(v-if="bubble.fuelType == 'Petrol'") Or ${{ petrolCost }} per month on petrol
                span.diesel-indicator(v-if="bubble.fuelType == 'Diesel'") Or ${{ dieselCost }} per month on diesel
      v-col(cols=12 lg=4)
        v-row
          v-col(cols=12, align="center")
            p Do you do any extra big trips throughout the year?
          v-col(cols=12) 
            v-row(align="baseline", justify="center")
              v-col.right.spacer(cols=1)
                v-btn.primary(fab, x-small, @click="visitRecommender")
                  v-icon mdi-plus
</template>

<script>
import AddressFinder from "./AddressFinder.vue";
import TripCardSupport from "../mixins/TripCardSupport.js";
export default {
  props: ["bubble"],
  mixins: [TripCardSupport],
  data() {
    return {
      settings: this.$dealer.user_settings
    };
  },
  computed: {
    petrolCost() {
      return this.formatPrice(
        ((this.bubble.kms * 4) / this.settings.petrolConsumption) *
          this.settings.petrolCost
      );
    },
    dieselCost() {
      var kms = this.bubble.kms * 4;
      var price =
        (kms / this.settings.dieselConsumption) * this.settings.dieselCost;
      var RUC = (kms / 1000) * this.settings.RUCperThousand;

      return this.formatPrice(price + RUC);
    },
  },
  components: {
    AddressFinder,
  },
  methods: {
    visitRecommender() {
      this.$router.push("recommender/1");
    },
    increment() {
      this.bubble.kms = parseFloat(this.bubble.kms) + 10;
    },
    decrement() {
      this.bubble.kms = Math.max(parseFloat(this.bubble.kms) - 10, 0);
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
}
.detail {
  color: #666666;
  font-size: 0.8em;
}
.per {
  font-style: italic;
  text-align: center;
  width: 100%;
  display: block;
}
.spacer {
  height: 24px;
}
.spacer * {
  position: relative;
  top: 50%;
}
.swatch {
  width: 12px;
  height: 12px;
  content: " ";
  display: block;
  background: blue;
}

.centered-input >>> input,
.center {
  text-align: center;
}

</style>